import "core-js/modules/es.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "addSwiper",
  data: function data() {
    return {
      form: {
        id: "",
        name: "",
        img: "",
        url: "",
        sort: "",
        is_open: "",
        language: "" // status: 1,

      },
      dialogShow: false,
      fileList: [],
      rules: {
        // sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        name: [{
          required: true,
          message: "请输入名字",
          trigger: "blur"
        }],
        img: [{
          required: true,
          message: "请上传图片",
          trigger: "blur"
        }],
        language: [{
          required: true,
          message: "请选择语言",
          trigger: "blur"
        }],
        is_open: [{
          required: true,
          message: "请选择状态",
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  _this.form = {
                    id: data.id,
                    name: data.name,
                    img: data.img,
                    url: data.url,
                    // sort: data.sort,
                    is_open: data.is_open,
                    language: data.language
                  };
                  _this.fileList = [data.img];
                }

                _this.dialogShow = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    imgChange: function imgChange(e) {
      this.fileList = e;
      this.form.img = e[0] && e[0].response ? e[0].response.data : '';
    },
    hide: function hide() {
      this.dialogShow = false;
    },
    clearData: function clearData() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.form = {
        id: type ? this.form.id : "",
        name: "",
        // sort: "",
        img: "",
        url: "",
        is_open: "",
        language: ""
      };
      this.fileList = [];
      this.$refs.ruleForm.resetFields();
    },
    submitData: function submitData() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var reqFn = _this2.form.id ? 'socialUpdate' : 'socialAdd';

          _this2.$api[reqFn](_this2.form).then(function (res) {
            if (res.code == 0) {
              _this2.$message({
                message: '操作成功',
                type: 'success'
              });

              _this2.hide();

              _this2.$emit('change');
            }
          });
        }
      });
    }
  }
};